<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Section: Intro Text -->
  <div class="intro-section">
    <p>
Nous avons constitué une équipe expérimentée de passionnés ayant une motivation naturelle à faire
pour le mieux dans le strict intérêt des clients.
    </p>
    <p>
Chacun de nous possède respectivement plusieurs années d’expérience professionnelle dans le
secteur de l’assurance avec des orientations et parcours complémentaires sur les aspects
commerciaux et juridiques
    </p>
    <p>
Notre équipe est soudée, polyvalente, réactive et en dialogue continu avec ses clients. Nous cultivons
l’analyse, l’action avec bon sens, la productivité, le souci du détail et le travail bien fait
    </p>
    <p>
Nous aimons expliquer les choses et transmettre notre connaissance des différents produits
commercialisés. Nous faisons une veille concurrentielle assidue pour trouver les produits nouveaux et
répondants de manière plus appropriée aux besoins de nos clients.
    </p>
  </div>

  <!-- Team Members Grid -->
  <div class="team-grid">
    <!-- Member 1: H.BH -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-homme.png" alt="Avatar H.BH">
      </div>
      <h3>H.BH - Gérant et Expert en Assurance Dommage</h3>
      <p>
        Plus de 20 ans dans le milieu de l’Assurance, aussi bien dans le domaine de la Protection
Sociale (Santé, Prévoyance, Retraite) que l’IARD, et parfaite compréhesion des problématiques
entreprise
      </p>
    </div>

    <!-- Member 2: Y.R -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-homme.png" alt="Avatar Y.R">
      </div>
      <h3>Y.R - Expert en Assurance emprunteur</h3>
      <p>
        Près de 10 ans dans le conseil et la commercialisation de contrats d’assurance de prêt. Avec
près de 3000 contrats signés, il est considéré comme un expert hors du commun dans ce
domaine.

      </p>
    </div>

    <!-- Member 3: E.M -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-homme.png" alt="Avatar E.M">
      </div>
      <h3>E.M - Expert Assurance Santé & Emprunteur</h3>
      <p>
      Près de 10 ans dans le conseil et la commercialisation de contrats d’assurance Mutuelle Santé
et 5 dans dans l’Assurance de Prêt. Avec près de 1500 contrats signés en santé, il détermine le
bon contrat après 1 minute d’échange.

      </p>
    </div>

    <!-- Member 4: L.B -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-femme.png" alt="Avatar L.B">
      </div>
      <h3>L.B - Expert Assurance Santé et Emprunteur</h3>
      <p>
Près de 5 ans dans l’assurance Santé, et la petite prévoyance comme l’assurance Accident de la
vie, l’obsèques et le décès.
      </p>
    </div>

    <!-- Member 5: S.D -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-homme.png" alt="Avatar S.D">
      </div>
      <h3>S.D - Expert Assurance Santé et Prévoyance</h3>
      <p>
        Près de 5 ans dans l’assurance Santé, Prévoyance et Epargne Retraite des TNS. Il propose des
couvertures de qualités à ses clients Indépendants.

      </p>
    </div>

    <!-- Member 6: D.Q -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-femme.png" alt="Avatar D.Q">
      </div>
      <h3>D.Q - Expert Assurance Santé et Emprunteur</h3>
      <p>
        Près de 5 ans dans l’assurance Santé, et l’assurance emprunteur au sein de grands assureurs
comme AXA ou ALLIANZ.
      </p>
    </div>

    <!-- Member 7: C.R -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-femme.png" alt="Avatar C.R">
      </div>
      <h3>C.R - Expert en Assurance Santé</h3>
      <p>
        Parfaite connaissance des processus de gestion des contrats d’assurance Santé et Assurance
Crédit. Deux ans d’expérience dans la commercialisation de contrats d’assurance Santé
      </p>
    </div>

    <!-- Member 8: C.F -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-femme.png" alt="Avatar C.F">
      </div>
      <h3>C.F - Expert Assurance Santé et  Emprunteur</h3>
      <p>
        Parfaite connaissance des processus de gestion des contrats d’Assurance Crédit. Deux ans
d’expérience dans la commercialisation de contrats d’assurance Prévoyance, notamment le Prêt.

      </p>
    </div>

    <!-- Member 9: M.P -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-homme.png" alt="Avatar M.P">
      </div>
      <h3>M.P - Expert Assurance IARD / Assurance Immobilier</h3>
      <p>
Expérience vaste dans le milieu de l’immobilier et des assurance associées (MRH, PNE, PNO,
MRI, GLI, DO, MRP, MRC, PJ Bailleur)

      </p>
    </div>

    <!-- Member 10: S.BA -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-homme.png" alt="Avatar S.BA">
      </div>
      <h3>S.BA - Informaticien Expert en Digital</h3>
      <p>
        Au sein du service Digital du Cabinet, Création et gestion des aspects numérique FullStack du
Cabinet
      </p>
    </div>

    <!-- Member 11: D.N -->
    <div class="team-member">
      <div class="member-avatar">
        <img src="assets/static_pages_images/Avatar-homme.png" alt="Avatar D.N">
      </div>
      <h3>D.N - Informaticien Expert Intelligence Artificielle</h3>
      <p>
Au sein du Service Digital du Cabinet, création d’outils digitaux dans le domaine du marketing.
      </p>
    </div>
  </div>

</app-page-layout>